import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Radio } from 'react-bootstrap';

import _ from 'helpers/no_conflict_lodash';

import './styles.scss';
import { tagProps } from './tag_table';

export default function MergeTagsModal({
  modalDisplay,
  selectedTag,
  selectedTags,
  onCloseModal,
  onMergeTags,
  onSelect
}) {
  const countData = () => {
    const mappedInstanceCount = _.map(selectedTags, tag => (
      tag.recordCountByType.totalCount
    ));

    const totalInstances = _.reduce(mappedInstanceCount, (sum, instances) => {
      return sum + instances;
    }, 0);

    return { totalTags: selectedTags.length, totalInstances: totalInstances };
  };

  const   handleTagSelect = (e) => {
    const tag = _.find(selectedTags, tag => (tag.id === parseInt(e.target.id)));

    onSelect(tag);
  };

  const setSelectableTags = () => {
    return _.map(selectedTags, tag => (
      <Radio
        checked={selectedTag === tag}
        className="radio clear-required"
        id={tag.id}
        key={tag.id}
        name={tag.name}
        onChange={handleTagSelect}
      >
        {tag.name}
      </Radio>
    ));
  };

  const renderTagInstanceMessage = () => {
    const countedData = countData();
    let instanceMessage;

    if (countedData.totalInstances > 0) {
      const pluralize = countedData.totalInstances === 1 ? '1 instance' : `${countedData.totalInstances} instances`;
      instanceMessage = <span> that have <strong>{pluralize}</strong></span>;
    }

    return (
      <p className="label-light">
        You are about to merge <strong>{countedData.totalTags} tags</strong>{instanceMessage}.
        Select the tag name that you would like everything merged under.
      </p>
    );
  };

  const renderTagForm = () => {
    return (
      <div className="form-group">
        {renderTagInstanceMessage()}
        <div className="form-input-container">
          {setSelectableTags()}
        </div>
      </div>
    );
  };

  const renderTagFooter = () => {
    return (
      <div>
        <button className="btn btn-cancel btn-sm" name="cancel" onClick={onCloseModal}>
          Cancel
        </button>
        <button className="btn btn-save btn-sm" disabled={selectedTag == null} name="save" onClick={onMergeTags}>
          Merge Tags
        </button>
      </div>
    );
  };

  return (
    <div>
      <Modal
        bsSize="sm"
        name="tag-form-modal"
        show={modalDisplay}
        onHide={onCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Merge Tags
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="tags-modal-body">
            {renderTagForm()}
          </div>
          <div className="tags-modal-actions">
            {renderTagFooter()}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

MergeTagsModal.propTypes = {
  modalDisplay: PropTypes.bool,
  selectedTag: PropTypes.object,
  selectedTags: PropTypes.arrayOf(tagProps).isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onMergeTags: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};
